<template>
  <div class="internalTrainingList">
    <heads></heads>
    <div class="container" ref="containerRef" v-if="!loading">
      <div class="container-left" ref="containerLeftRef">
        <div class="training-detail-header">
          <div class="header-title">{{detailResult.title}}</div>
          <div class="header-type">课程分类<span>{{detailResult.internalTrainingTypeName}}</span></div>
          <div class="header-duration">课程时长<span>{{detailResult.courseTime}}</span></div>
          <div class="header-method">授课方式<span>{{detailResult.courseWayDescription}}</span></div>
          <div class="header-crowds">适用人群<span>{{detailResult.fitPeople}}</span></div>
        </div>
        <div class="training-detail-title">
          <img
            src="../../assets/pic/detail-background.png"
          />
          <span>课程收益</span>
        </div>
        <div class="training-detail-article">
         {{detailResult.courseBenefit}}
        </div>
        <div class="training-detail-title">
          <img
            src="../../assets/pic/detail-background.png"
          />
          <span>课程背景</span>
        </div>
        <div class="training-detail-article">
         {{detailResult.courseBackground}}
        </div>
        <div class="training-detail-title">
          <img
            src="../../assets/pic/detail-background.png"
          />
          <span>课程大纲</span>
        </div>
        <div class="training-detail-table">
          <el-table :data="outlineList" border style="width: 100%">
            <el-table-column prop="title" label="标题" width="200">
            </el-table-column>
            <el-table-column label="内容" width="526">
              <template slot-scope="scope">
                <div v-html="scope.row.content"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="training-detail-title">
          <img
            src="../../assets/pic/detail-background.png"
          />
          <span>服务流程</span>
        </div>
        <div class="training-detail-process">
          <div class="training-detail-process-item" v-for="(item,index) in processArray" :key="item.id" :class="index == processArray.length-1?'flex-little':''">
            <div class="training-detail-process-part1">
            <img
              :src="item.path"
            />
            <span>{{item.title}}</span>
            <p>{{item.description}}</p>
          </div>
            <div class="arrow" v-if="index < processArray.length-1">-></div>
          </div>
          </div>

        <div class="header"></div>
      </div>
      <div class="container-right">
        <!--定制方案区-->
        <div
          class="free-booking"
          ref="freeBookingRef"
          :class="freeBookingStyle == 1 ? 'free-booking-1' : 'free-booking-2'"
          :style="freeBookingStyle == 2 ? { top: topHeight } : ''"
        >
          <div class="free-booking-header">
            <span class="free-booking-dot"></span>
            <span class="free-booking-title">定制咨询服务</span>
            <span class="free-booking-dot"></span>
          </div>
          <div class="free-booking-item free-booking-item2">
            <span class="txt">联系人</span>
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
          <div class="free-booking-item free-booking-item2">
            <span class="txt request">联系电话</span>
            <el-input
              v-model="form.mobile"
              placeholder="联系电话"
              style="display: inline"
            ></el-input>
          </div>
          <div class="free-booking-item">
            <span class="txt request">验证码</span>
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
                            <span
                class="txt2"
                :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span
              >
            </div>
          </div>
          <div class="element-row">
            <div class="free-booking-item">
              <div
                class="
                  tool-button
                  free-booking-item-order-submit
                  tool-button-primary
                "
              >
                <button @click="submit">提交需求</button>
              </div>
            </div>
          </div>
        </div>
        <!-- 定制方案区 -->
      </div>
    </div>
    <div class="loading-page" v-if="loading"  v-loading="loading">
      <!-- <el-empty description="加载中"></el-empty> -->
    </div>
    <homeFoots></homeFoots>
   <quickContact :message="quickContactMessage"></quickContact>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre,isPhoneNumber } from "@/util/util.js";

import axios from "axios";
import wxShare from "@/common/wx_share.js";
export default {
  name: "internalTrainingList",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      id: 0,
      pageArray: [],

      loading: false,
      //
      testList: [1, 2, 3, 4, 5, 5, 6, 7, 8, 9, 10],
      freeBookingStyle: 2,
      topHeight: "0px",
      article: "",
      isShowCatagory: false,
      // -- 免费定制
      // 提交表单
      form: {
        contact: null,
        mobile: "",
        verificationCode: "",
      },
      // -- 免费定制

      // 短信倒计时
      smsCodeTime: 0,
      // 流程列表
      processArray:[],
      // 大纲列表
      outlineList:[],
      // 内训明细
      detailResult:[],
      quickContactMessage:{
        type:1
      },
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
    // nav() {
    //   return this.$route.params.id;
    // }
  },
  methods: {
    isPhoneNumber,
    handlePicPlusPre,
    // fomateDate,
    showCatagory() {
      this.isShowCatagory = true;
    },
    selectCatagory() {
      this.isShowCatagory = false;
    },
    toDetail(id) {
      this.$router.push({
        path: "/internalTrainingDetail",
        query: { id: id },
      });
    },
    // 计算免费定制的显示
    handleScrollx() {
      let containerBottom =
        this.$refs.containerRef.getBoundingClientRect().bottom;
      let freeBookingRefHeight = this.$refs.freeBookingRef.offsetHeight;
      if (containerBottom - freeBookingRefHeight - 120 >= 0) {
        this.freeBookingStyle = 1;
        return;
      } else {
        this.freeBookingStyle = 2;
      }

      // 计算触底位置
      // console.log(containerBottom);
      // console.log(freeBookingRefHeight);
      if (containerBottom - freeBookingRefHeight - 60 < 0) {
        console.log("--计算触底位置-");
        let containerRefHeight = this.$refs.containerRef.offsetHeight;
        this.topHeight = containerRefHeight - freeBookingRefHeight - 60 + "px";
        // console.log(this.topHeight);
      }
    },
      // 线下，线上方式
    getCourseWay(courseWay) {
      let courseWayDescription = "";
      if (courseWay == 1) {
        courseWayDescription = "线下";
      } else if (courseWay == 2) {
        courseWayDescription = "线上";
      } else {
        courseWayDescription = "";
      }
      return courseWayDescription;
    },
    //获取内训明细
    getInternalTrainingDetail() {
      this.loading = true;
      axios.get(`/api/internalTraining/` + this.id).then((res) => {
        if (res.data && res.data.code == 200) {
          this.detailResult = res.data.data.lxqInternalTraining;
          this.outlineList = res.data.data.outlineList;
          // console.log("this.detailResult")
          // console.log(this.detailResult)
          if (this.detailResult.courseWay) {
            this.detailResult.courseWayDescription = this.getCourseWay(this.detailResult.courseWay);
          }
          if (this.detailResult.title) {
              document.title = this.detailResult.title;
          }
        }
        this.loading = false;
      }).catch (e=>{
        this.loading = true;
      });
    },
    // 获取流程图
    getProcessPic() {
      const params = {
        positionId: 12,
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if (res.data && res.data.code == 200) {
            this.processArray = res.data.adList;

            this.processArray.forEach((process) => {
              if (process.path) {
                process.path = this.handlePicPlusPre(process.path);
                process.path = process.path[0];
              }
            });
            // console.log("getAdPosition-middle")
            // console.log(this.processArray);
          }
          // console.log("getAdPosition-end")
        });
    },
    clearForm(){
      // 提交表单
      this.form = {
        // peopleNumber: null,
        // avgPrice: null,
        // activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        // wxNo: null,
        // description: null,
      }
    },
    // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // this.form = {
      //   mobile,
      //   verificationCode,
      // };
      this.form.type = "3";
      let params = this.form;
      // let params = {
      //   peopleNumber: "",
      //   avgBudget: "",
      //   teamBuildingDay: "",
      //   contact: "",
      //   mobile: "",
      //   verificationCode: "",
      //   wxNo: "",
      //   description: "",
      // };
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.clearForm();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInternalTrainingDetail();
    this.getProcessPic();
    this.handleScrollx();
    window.addEventListener("scroll", this.handleScrollx, true);
        // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 1060px;
  min-height: 400px;
}
.container-left {
  width: 726px;
}
.training-detail-header {
  position: relative;
  width: 100%;
  height: 200px;
  background: #222;
  border-radius: 6px;
  margin-bottom: 10px;
}
.training-detail-header span {
  padding-left: 20px;
  font-size: 14px;
  color: #fff;
}
.training-detail-header .header-title {
  position: absolute;
  font-size: 28px;
  color: #ebd0a3;
  left: 35px;
  top: 32px;
  font-weight: 700;
}
.training-detail-header .header-type {
  font-size: 16px;
  color: #ebd0a3;
  position: absolute;
  left: 35px;
  top: 105px;
}
.training-detail-header .header-duration {
  font-size: 16px;
  color: #ebd0a3;
  position: absolute;
  left: 35px;
  top: 138px;
}
.training-detail-header .header-method {
  font-size: 16px;
  color: #ebd0a3;
  position: absolute;
  left: 207px;
  top: 138px;
}
.training-detail-header .header-crowds {
  font-size: 16px;
  color: #ebd0a3;
  position: absolute;
  left: 207px;
  top: 105px;
}
.training-detail-title {
  position: relative;
  padding: 10px;
}
.training-detail-title img {
  vertical-align: middle;
  width: 30px;
  height: 30px;
  display: inline-block;
}
.training-detail-title span {
  font-size: 20px;
  color: #222;
  font-weight: 700;
  line-height: 30px;
  height: 30px;
  position: absolute;
  left: 50px;
  top: 10px;
}
.training-detail-article {
  font-size: 14px;
  color: #222;
  line-height: 22px;
  /* padding: 0px 0 0px 40px; */
  padding-left: 40px;
  /* white-space: pre-wrap; */
}
.training-detail-process {
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  margin-top: 20px;
  align-content: center;
}
.training-detail-process .training-detail-process-item {
  flex: 1;
  display:flex  ;
}
.training-detail-process .flex-little{
  flex: 0.5!important;
  display:flex  ;
}
.training-detail-process-part1{
  flex: 1;
}
.training-detail-process .arrow {
  color: #ecd1a5;
  flex: 1;
  line-height: 80px;
  text-align: center;
}
.training-detail-process-item span {
  font-size: 15px;
  color: #222;
  font-weight: 700;
  text-align: center;
  display: block;
}
.training-detail-process-item img {
  width: 100%;
  height: 55px;
  -o-object-fit: contain;
  object-fit: contain;
}
.training-detail-process-item p {
  font-size: 12px;
  color: #666;
  text-align: center;
  padding: 10px 0;
}
.container-right {
  font-size: 12px;
  color: #666;
  text-align: center;
  padding: 10px 0;
}
.container-left >>> .el-table {
  margin: 10px 0px;
}
.container-left >>> .has-gutter .cell {
  text-align: center;
  font-weight: 700;
  background-color: #c2e2fd;
  color: #222;
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.container-left >>> .has-gutter th {
  background-color: #c2e2fd;
}
.container-left >>> .el-table__row .cell {
  padding: 10px 20px;
  /* border: 1px solid #dedede; */
  font-size: 14px;
  color: #222;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
}
.container-left >>> .el-table--scrollable-x .el-table__body-wrapper {
  overflow: hidden !important;
}

/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;

  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fff;
  border: 2px solid #359ff8;
  border-radius: 3px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #222;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  font-size: 16px;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 60px;
  padding-right: 5px;
}
.request::before {
  content: "*";
  color: red;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 250px;
  height: 100%;
  cursor: pointer;
}
.free-booking-itemimg {
  margin-top: 30px;
  width: 600px;
}
.element-row {
  flex-flow: row wrap;
}
.tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  background: #222;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
}
.loading-page{
  height: 800px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/internalTraining/internalTrainingDetail.vue